<template>
    <div class="resource-page">
        <div class="resource-header">
            <a-row>
                <a-col :span="6">
                    <div class="resource-logo">
                        <img src="@/assets/img/logo_text.png" alt="">
                    </div>
                </a-col>
                <a-col :span="10">
                    <div class="res-nav-box">
                        <router-link :to="item.url" v-for="(item,index) in data_type_nav" :key="index">
                            <div :class="item.code == contentType?'res-nav-item active' :'res-nav-item'">
                                <img class="res-nav-item-img" :src="item.img_url" alt="">
                                <div class="res-nav-item-txt">{{ item.title }}</div>
                            </div>
                        </router-link>
                    </div>
                </a-col>
                <a-col :span="4">
                    <div class="search-box">
                        <a-input-search v-model:value="keyword" placeholder="请输入搜索关键字" size="large" style="width: 200px"
                            @search="onSearch" />
                    </div>
                </a-col>
                <a-col :span="4">
                    <div class="header-user">
                        <img class="user-header" src="@/assets/img/ic_user_g.png" alt="">
                        <div class="header-user-info">
                            <div>{{ adminUserInfo.user_name }}</div>
                            <div>{{ adminUserInfo.real_name }}</div>
                        </div>
                        <div class="logout-box" @click.stop="logout">
                            <img class="logout-img" src="@/assets/img/ic_logout.png" alt="">
                            <div>退出</div>
                        </div>
                    </div>
                </a-col>
            </a-row>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import {
        defineComponent,
        ref,
        reactive,
        computed,
        onMounted,
    } from "vue";
    import router from "@/router";
    import {
        useRoute,
    } from "vue-router";
    import {
        useStore
    } from "vuex";

    import * as Api from "@/views/resource/api";


    export default defineComponent({
        components: {},

        setup() {
            const route = useRoute();
            const store = useStore();

            // 获取当前导航位置

            // console.log(router.currentRoute.value.name);

            const contentType = computed(() => {
                return router.currentRoute.value.name;
            });

            const data_type_nav = ref([]);

            onMounted(() => {
                // 获取资源类别
                Api.data_type_list().then((res) => {
                    if (res.status == 200) {
                        data_type_nav.value = res.data;
                    }
                });
                getAdminUserInfo();
            });

            const admin_user = ref(store.state.user.username);

            // 注销登录
            const logout = () => {
                store.dispatch("user/logout");
                router.push({
                    path: "/login"
                });
                localStorage.clear();
            };

            // 返回上一页
            const goback = () => {
                router.go(-1);
            };
            //修改密码
            const updatePassWord = () => {
                router.push({
                    path: "/manage/system/user"
                });
            }

            const adminUserInfo = reactive({
                user_name: '',
                real_name: ''
            });

            const getAdminUserInfo = () => {
                Api.api_admin_user_info().then((res) => {
                    if (res.status == 200) {
                        console.log(res)
                        adminUserInfo.user_name = res.data.user_name;
                        adminUserInfo.real_name = res.data.real_name;
                    }
                });
            }

            const localNav = computed(() => {
                return route.matched;
            });

            const keyword = ref('');

            const onSearch = () => {
                router.push({
                    path: "/resource/search",
                    query: {
                        keyword: keyword.value
                    },
                });
            }

            return {
                keyword,
                onSearch,
                admin_user,
                adminUserInfo,
                getAdminUserInfo,
                localNav,
                logout,
                goback,
                updatePassWord,
                collapsed: ref(false),
                data_type_nav,
                contentType
            };
        },
    });
</script>